var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #565d6d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.12,13.67c0,.43-.19.85-.53,1.15-.34.31-.81.48-1.29.48H5.28c-.48,0-.95.17-1.29.48l-2.01,1.8c-.09.08-.21.14-.33.16-.13.02-.26.01-.37-.03s-.22-.12-.29-.21c-.07-.1-.11-.21-.11-.32V3.88c0-.43.19-.85.53-1.15s.81-.48,1.29-.48h14.59c.48,0,.95.17,1.29.48.34.31.53.72.53,1.15v9.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactRequest);
export default __webpack_public_path__ + "static/media/contact-request.f1bf2cb99dae0f01f503dbbab15f62cc.svg";
export { ForwardRef as ReactComponent };